import { zodSortField } from "@/lib/utils";
import { z } from "zod";

export const deleteShippingSiteSchema = z.object({
  id: z.number(),
});

export const getShippingSitesRequestSchema = z.object({
  sort: zodSortField(["name"]),
});

export const addShippingSiteSchema = z.object({
  name: z
    .string()
    .min(1, "Le nom est requis")
    .max(200, "Maximum de caractères atteint"),
  postalCode: z.string().regex(/^\d{5}/, "Le code postal est incohérent"),
});

export const editShippingSiteSchema = z.object({
  id: z.number().optional(),
  name: z
    .string()
    .min(1, "Le nom est requis")
    .max(200, "Maximum de caractères atteint"),
  postalCode: z.string().regex(/^\d{5}/, "Le code postal est incohérent"),
  isActive: z.boolean().default(true),
});
